import Echarts from "echarts";
import china from "@/assets/geo/goodsCirculation/china.json";
import guangdong from "@/assets/geo/guangdong/inline.json";
import goldMedal from "@/assets/images/alarmBoard/goldMedal.png";
import silverMedal from "@/assets/images/alarmBoard/silverMedal.png";
import bronzeMedal from "@/assets/images/alarmBoard/bronzeMedal.png";
const windowWidth = window.innerWidth;
let fontSize = windowWidth / 20; // 根据需要调整比例

function drawTopChart(el, { dataX = [], dataValue = [] }) {
  const myChart = Echarts.init(el);
  const option = {
    title: {
      // text: "· 城市冷链配送企业排行Top5",
      textStyle: {
        fontSize: 0.18 * fontSize
      }
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      },
      formatter: function(params) {
        return params[0].value;
      }
    },
    legend: {
      show: false
    },
    grid: {
      left: "5%",
      right: "8%",
      top: "12%",
      bottom: "0%",
      containLabel: true
    },
    xAxis: {
      show: false,
      type: "value"
    },
    yAxis: [
      {
        type: "category",
        inverse: true,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisPointer: {
          label: {
            show: true,
            margin: 0.3 * fontSize
          }
        },
        data: dataX,
        axisLabel: {
          margin: 0.4 * fontSize,
          fontSize: 0.14 * fontSize,
          align: "left",
          color: "#333",
          rich: {
            a1: {
              color: "#fff",
              backgroundColor: {
                image: goldMedal
              },
              width: 0.3 * fontSize,
              height: 0.3 * fontSize,
              align: "center",
              top: 0
            },
            a2: {
              color: "#fff",
              backgroundColor: {
                image: silverMedal
              },
              width: 0.3 * fontSize,
              height: 0.3 * fontSize,
              align: "center"
            },
            a3: {
              color: "#fff",
              backgroundColor: {
                image: bronzeMedal
              },
              width: 0.3 * fontSize,
              height: 0.3 * fontSize,
              align: "center"
            },
            b: {
              color: "#333",
              width: 0.3 * fontSize,
              height: 0.3 * fontSize,
              align: "center"
            }
          },
          formatter: function(params) {
            var index = dataX.map(name => name).indexOf(params);
            index = index + 1;
            if (index - 1 < 3) {
              return ["{a" + index + "|" + index + "}"].join("\n");
            } else {
              return ["{b|" + index + "}"].join("\n");
            }
          }
        }
      },
      {
        type: "category",
        inverse: true,
        axisTick: "none",
        axisLine: "none",
        show: true,
        data: dataValue,
        axisLabel: {
          show: true,
          fontSize: 0.14 * fontSize,
          color: "#333",
          formatter: "{value}"
        }
      }
    ],
    series: [
      {
        z: 2,
        name: "value",
        type: "bar",
        barCategoryGap: "40%",
        barGap: "30%",
        barWidth: 0.14 * fontSize,
        data: dataValue.map(value => {
          var itemStyle = {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                {
                  offset: 0,
                  color: "#fff" //  0%  处的颜色
                },
                {
                  offset: 1,
                  color: "#274DF2" //  100%  处的颜色
                }
              ],
              global: false //  缺省为  false
            },
            barBorderColor: "#274DF2", // 边框色
            barBorderWidth: 1, // 边框宽度
            barBorderRadius: [10, 10, 10, 10]
          };
          return {
            value: value,
            itemStyle: itemStyle
          };
        }),
        label: {
          normal: {
            color: "#666",
            show: true,
            position: [0, 0.24 * fontSize + "px"],
            textStyle: {
              fontSize: 0.14 * fontSize
            },
            formatter: function(a) {
              return a.name;
            }
          }
        }
      }
    ]
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
    myChart.resize();
  });
}

function drawPillarLineChart(
  el,
  { dataX, barData, lineData, dryBarData, dryLineData, colorConfig = {} }
) {
  const myChart = Echarts.init(el);

  const option = {
    //你的代码
    title: {
      // text: "城市冷链配送车辆每周运营走势",
      textStyle: {
        fontSize: 0.18 * fontSize
      }
    },
    tooltip: {
      backgroundColor: "rgba(13, 64, 71, 0.50)",
      borderColor: "rgba(143, 225, 252, 0.60)",
      padding: 0.8 * fontSize,
      textStyle: {
        color: "#fff"
      },

      formatter: function(params) {
        return params.seriesName + "：" + params.data;
      }
    },
    legend: {
      data: ["干货运行公里", "干货运行时长", "冷链运行公里", "冷链运行时长"],
      right: 0.3 * fontSize,
      top: 0.4 * fontSize,
      textStyle: {
        fontSize: 0.14 * fontSize,
        color: "#333"
      }
    },
    grid: {
      left: "5%",
      right: "5%",
      top: "35%",
      bottom: "7%",
      containLabel: true
    },
    xAxis: [
      {
        type: "category",
        data: dataX,
        axisTick: {
          show: false // 不显示坐标轴刻度线
        },
        axisLine: {
          // 轴线设置
          show: true, // 显示轴线
          lineStyle: {
            // 轴线样式设置
            color: "#C5C5C5", // 轴线颜色
            width: 1, // 轴线宽度
            type: "solid" // 轴线类型-虚线
          }
        },
        axisLabel: {
          textStyle: {
            color: "#333", //更改坐标轴文字颜色
            fontSize: 0.12 * fontSize //更改坐标轴文字大小
          }
        }
      }
    ],
    yAxis: [
      {
        name: "公里",
        axisTick: {
          show: false // 不显示坐标轴刻度线
        },
        nameTextStyle: {
          align: "right"
        },
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#979797",
            type: [5, 10]
          }
        },
        axisLabel: {
          textStyle: {
            color: "#333", //更改坐标轴文字颜色
            fontSize: 0.12 * fontSize //更改坐标轴文字大小
          }
        }
      },
      // 折线部分
      {
        type: "value",
        name: "小时",
        axisTick: {
          show: false // 不显示坐标轴刻度线
        },
        nameTextStyle: {
          align: "left"
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          textStyle: {
            color: "#333", //更改坐标轴文字颜色
            fontSize: 0.12 * fontSize //更改坐标轴文字大小
          },
          formatter: "{value}"
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "#979797",
            type: [5, 10]
          }
        }
      }
    ],
    series: [
      // 数据顶部的样式 - 干货
      {
        name: "干货运行公里",
        type: "pictorialBar",
        barWidth: 0.14 * fontSize,
        barGap: "20%",
        symbolSize: [0.14 * fontSize, 0.1 * fontSize],
        symbolOffset: [0, -0.05 * fontSize],
        z: 2,
        itemStyle: {
          normal: {
            opacity: 1,
            color: colorConfig.barDryColor[2]
          }
        },
        symbolPosition: "end",
        data: dryBarData
      },
      // 数据的柱状图1 - 干货
      {
        name: "干货运行公里",
        type: "bar",
        barWidth: 0.14 * fontSize,
        barGap: "20%",
        z: 1,
        itemStyle: {
          opacity: 1, // 这个是 透明度
          color: new Echarts.graphic.LinearGradient(
            0,
            1,
            0,
            0,
            [
              {
                offset: 1,
                color: colorConfig.barDryColor[1] // 0% 处的颜色
              },
              {
                offset: 0,
                color: colorConfig.barDryColor[2] // 100% 处的颜色
              }
            ],
            false
          )
        },
        data: dryBarData
      },

      // 折线部分1
      {
        name: "干货运行时长",
        type: "line",
        yAxisIndex: 1,
        symbol: "circle",
        smooth: true,
        symbolSize: 0.1 * fontSize,
        itemStyle: {
          shadowBlur: 0,
          color: colorConfig.lineDryColor[0]
        },
        label: {
          show: false,
          position: "top"
        },
        areaStyle: {
          normal: {
            color: new Echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(237,75,105,.3)"
                },
                {
                  offset: 1,
                  color: "rgba(174, 112, 79, 0)"
                }
              ],
              false
            )
          }
        },
        data: dryLineData
      },
      // 数据顶部的样式 - 冷链
      {
        name: "冷链运行公里",
        type: "pictorialBar",
        barWidth: 0.14 * fontSize,
        barGap: "20%",
        symbolSize: [0.14 * fontSize, 0.1 * fontSize],
        symbolOffset: [0, -0.05 * fontSize],
        z: 2,
        itemStyle: {
          normal: {
            opacity: 1,
            color: colorConfig.barColor[0]
          }
        },
        symbolPosition: "end",
        data: barData
      },
      // 数据的柱状图1 - 冷链
      {
        name: "冷链运行公里",
        type: "bar",
        barWidth: 0.14 * fontSize,
        barGap: "20%",
        z: 1,
        itemStyle: {
          opacity: 1, // 这个是 透明度
          color: new Echarts.graphic.LinearGradient(
            0,
            1,
            0,
            0,
            [
              {
                offset: 1,
                color: colorConfig.barColor[1] // 0% 处的颜色
              },
              {
                offset: 0,
                color: colorConfig.barColor[2] // 100% 处的颜色
              }
            ],
            false
          )
        },
        data: barData
      },

      // 折线部分1
      {
        name: "冷链运行时长",
        type: "line",
        yAxisIndex: 1,
        symbol: "circle",
        smooth: true,
        symbolSize: 0.1 * fontSize,
        itemStyle: {
          shadowBlur: 0,
          color: colorConfig.lineColor[0]
        },
        label: {
          show: false,
          position: "top"
        },
        areaStyle: {
          normal: {
            color: new Echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(237,75,105,.3)"
                },
                {
                  offset: 1,
                  color: "rgba(174, 112, 79, 0)"
                }
              ],
              false
            )
          }
        },
        data: lineData
      }
    ]
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
    myChart.resize();
  });
}

function drawPillarChart(el, { dataX, morningData, eveningData }) {
  const myChart = Echarts.init(el);

  const bottomData = [];
  for (let i = 0; i < dataX; i++) {
    bottomData.push(0.5);
  }
  const option = {
    //你的代码
    title: {
      // text: "广州市限行区域早晚高峰冷藏车运行情况",
      left: "10",
      textStyle: {
        fontSize: 0.18 * fontSize
      }
    },
    tooltip: {
      backgroundColor: "rgba(13, 64, 71, 0.50)",
      borderColor: "rgba(143, 225, 252, 0.60)",
      padding: 0.08 * fontSize,
      textStyle: {
        color: "#fff"
      }
    },
    legend: {
      data: ["干货车", "冷链车"],
      left: 0.3 * fontSize,
      top: 0.45 * fontSize,
      itemWidth: 0.08 * fontSize,
      itemHeight: 0.08 * fontSize,
      textStyle: {
        fontSize: 0.14 * fontSize,
        color: "#333"
      },
      icon: "circle"
    },
    grid: {
      left: "10%",
      right: "5%",
      top: "30%",
      bottom: "15%"
    },
    xAxis: [
      {
        type: "category",
        data: dataX,
        axisTick: {
          show: false // 不显示坐标轴刻度线
        },
        axisLine: {
          // 轴线设置
          show: true, // 显示轴线
          lineStyle: {
            // 轴线样式设置
            color: "#C5C5C5", // 轴线颜色
            width: 1, // 轴线宽度
            type: "solid" // 轴线类型-虚线
          }
        },
        axisLabel: {
          textStyle: {
            color: "#333", //更改坐标轴文字颜色
            fontSize: 0.12 * fontSize //更改坐标轴文字大小
          }
        }
      }
    ],
    yAxis: [
      {
        axisTick: {
          show: false // 不显示坐标轴刻度线
        },
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: "#979797",
            type: [5, 10]
          }
        },
        axisLabel: {
          textStyle: {
            color: "#333", //更改坐标轴文字颜色
            fontSize: 0.12 * fontSize //更改坐标轴文字大小
          }
        }
      },
      // 折线部分
      {
        type: "value",
        name: "",
        axisTick: {
          show: false // 不显示坐标轴刻度线
        },
        axisLine: {
          show: false
        },
        axisLabel: {
          show: false,
          textStyle: {
            color: "#F5F5F5", //更改坐标轴文字颜色
            fontSize: 0.12 * fontSize //更改坐标轴文字大小
          },
          formatter: "{value}"
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "#979797",
            type: [5, 10]
          }
        }
      }
    ],
    series: [
      // 数据顶部的样式
      {
        name: "",
        type: "pictorialBar",
        symbolSize: [14, 8],
        symbolOffset: [-10.5, -6],
        z: 2,
        itemStyle: {
          normal: {
            opacity: 1,
            color: "#32CD32"
          }
        },
        symbolPosition: "end",
        data: morningData
      },
      // 数据的柱状图1
      {
        name: "冷链车",
        type: "bar",
        barWidth: 14,
        z: 1,
        itemStyle: {
          opacity: 1, // 这个是 透明度
          color: new Echarts.graphic.LinearGradient(
            0,
            1,
            0,
            0,
            [
              {
                offset: 1,
                color: "#90EE90" // 0% 处的颜色
              },
              {
                offset: 0,
                color: "#228B22" // 100% 处的颜色
              }
            ],
            false
          )
        },
        data: morningData
      },

      // 数据的柱状图2的顶部
      {
        name: "", // 头部
        type: "pictorialBar",
        symbolSize: [14, 8],
        symbolOffset: [10.5, -2],
        z: 12,
        symbolPosition: "end",
        itemStyle: {
          normal: {
            opacity: 1,
            color: "#FF8C00"
          }
        },
        data: eveningData
      },
      // 数据的柱状图2
      {
        name: "干货车",
        type: "bar",
        barWidth: 14,
        z: 2,
        barGap: "50%",
        itemStyle: {
          // lenged文本
          opacity: 1, // 这个是 透明度
          color: new Echarts.graphic.LinearGradient(
            //前4个参数用于配置渐变色的起止位置，这4个参数依次对应右/下/左/上四个方位，而0 0 0 1则代表渐变色从正上方开始。
            0,
            0,
            0,
            1,
            [
              {
                offset: 0,
                color: "#f8bc63" // 0% 处的颜色
              },
              {
                offset: 1,
                color: "#FF8C00" // 100% 处的颜色
              }
            ],
            false
          )
        },
        data: eveningData
      }
    ]
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
    myChart.resize();
  });
}

function drawDashBoardChart(
  el,
  {
    rateValue = 0,
    title = "",
    name = "",
    unit = "",
    color = ["#F3C81A", "#CB8B04", "#F7B45E"]
  }
) {
  const myChart = Echarts.init(el);

  const data = {
    name: title,
    value: [rateValue]
  };
  // 0色        1色      title色

  const option = {
    title: {
      text: `{a|${data.value[0] + unit}}{c|\n${name}}`,
      textStyle: {
        rich: {
          a: {
            fontSize: 0.16 * fontSize,
            color: "#333",
            fontWeight: "bolder"
          },
          c: {
            fontSize: 0.12 * fontSize,
            color: "#aaa",
            padding: [8, 0]
          }
        }
      },
      left: "center",
      top: name ? "53%" : "55%"
    },
    graphic: [
      {
        type: "text",
        z: 100,
        left: "center",
        top: "20%",
        style: {
          fill: "#333",
          text: data.name,
          fontWeight: "bolder",
          fontSize: 0.15 * fontSize
        }
      }
    ],
    tooltip: {
      show: false,
      formatter: function(params) {
        return params.value;
      }
    },
    angleAxis: {
      // 隐藏刻度线
      show: false,
      clockwise: true, // 逆时针
      startAngle: -60
    },
    radiusAxis: {
      type: "category",
      show: true,
      axisLabel: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    polar: [
      {
        center: ["50%", "60%"], //中心点位置
        radius: "80%" //图形大小
      }
    ],
    series: [
      {
        name: "小环",
        type: "gauge",
        splitNumber: 12,
        radius: "65%",
        center: ["50%", "60%"],
        startAngle: 0,
        endAngle: 359.9999,
        axisLine: {
          show: false
        },
        axisTick: {
          show: true,
          lineStyle: {
            color: color[0],
            width: 2
          },
          length: 10,
          splitNumber: 3
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          show: false
        },
        detail: {
          show: false
        }
      },
      {
        type: "bar",
        z: 10,
        data: data.value,
        showBackground: false,
        backgroundStyle: {
          color: color[1],
          borderWidth: 10,
          width: 10
        },
        coordinateSystem: "polar",
        barWidth: 0.14 * fontSize,
        itemStyle: {
          normal: {
            opacity: 1,
            color: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0,
                color: color[0]
              },
              {
                offset: 0.45,
                color: color[1]
              },
              {
                offset: 1,
                color: color[2]
              }
            ]),
            shadowBlur: 1,
            shadowColor: "yellow"
          }
        }
      },
      {
        type: "pie",
        name: "内层细圆环",
        radius: ["40%", "43%"],
        center: ["50%", "60%"],
        hoverAnimation: false,
        clockWise: true,
        itemStyle: {
          normal: {
            color: "#aaa"
          }
        },
        tooltip: {
          show: false
        },
        label: {
          show: false
        },
        data: [100]
      }
    ]
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
    myChart.resize();
  });
}

function drawRakingChart(
  el,
  {
    inverse = false,
    title = {},
    dataX = [],
    dataValue = [],
    showY = false,
    colorList = []
  }
) {
  console.log(showY);
  const myChart = Echarts.init(el);
  const option = {
    title: {
      text: title.text,
      top: title.top,
      left: title.left,
      right: title.right,
      textStyle: {
        fontSize: title.fontSize * fontSize
      }
    },
    tooltip: {
      trigger: "item",
      axisPointer: {
        type: "shadow"
      },
      formatter: function(params) {
        return params[0].value;
      }
    },
    legend: {
      show: false
    },
    grid: {
      left: "20%",
      right: "10%",
      top: "30%",
      bottom: "0%",
      containLabel: true
    },
    xAxis: {
      show: false,
      type: "value",
      inverse: inverse
    },
    yAxis: [
      {
        show: showY,
        type: "category",
        inverse: true,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisPointer: {
          label: {
            show: true,
            margin: 0.3 * fontSize
          }
        },
        data: dataX,
        axisLabel: {
          show: showY,
          textStyle: {
            color: "#000",
            fontSize: 0.14 * fontSize
          }
        }
      },
      {
        type: "category",
        inverse: true,
        axisTick: "none",
        axisLine: "none",
        show: showY,
        data: dataValue,
        axisLabel: {
          show: showY,
          fontSize: 0.14 * fontSize,
          color: "#fff",
          formatter: "{value}"
        }
      }
    ],
    series: [
      {
        z: 2,
        name: "value",
        type: "bar",
        barCategoryGap: "40%",
        barGap: "30%",
        barWidth: 0.14 * fontSize,
        data: dataValue.map(vehicleRate => {
          var itemStyle = {
            color: {
              type: "linear",
              x: 0,
              y: 0,
              x2: 1,
              y2: 0,
              colorStops: [
                {
                  offset: 0,
                  color: colorList[0] //  0%  处的颜色
                },
                {
                  offset: 0.7,
                  color: colorList[1] //  0%  处的颜色
                },
                {
                  offset: 1,
                  color: colorList[2] //  100%  处的颜色
                }
              ],
              global: false //  缺省为  false
            },
            barBorderRadius: [10, 10, 10, 10]
          };
          return {
            value: vehicleRate,
            itemStyle: itemStyle
          };
        }),
        label: {
          show: true,
          position: inverse ? "left" : "right",
          top: 0.1 * fontSize,
          fontSize: 0.14 * fontSize,
          color: "#333",
          formatter: function(params) {
            // 获取x轴和y轴的值
            // 从series的数据中获取对应的x轴值
            var dataIndex = params.dataIndex || 0;
            var xValue = (dataX && dataX[dataIndex]) || "";
            var yValue = params.value || 0;
            return xValue + "-" + yValue;
          }
        }
      }
    ]
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
    myChart.resize();
  });
}

function drawContrastChart(el, { labelData, leftData, rightData }) {
  const myChart = Echarts.init(el);

  let legend = ["车次", "车辆行驶总里程"];

  var option = {
    baseOption: {
      timeline: {
        show: false,
        top: 0,
        data: []
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow"
        },
        textStyle: {
          color: "#fff"
        },
        formatter: "{a} ：\n\n{c}"
      },
      legend: {
        show: false,
        top: "5%",
        right: "center",
        itemWidth: 0.2 * fontSize,
        itemHeight: 0.05 * fontSize,
        itemGap: 0.3 * fontSize,
        icon: "horizontal",
        textStyle: {
          color: "#333",
          fontSize: 0.14 * fontSize
        },
        data: legend
      },
      grid: [
        // 左边
        {
          show: false,
          left: "2%",
          top: "40%",
          bottom: "10%",
          containLabel: true,
          width: "37%"
        },
        // 中间
        {
          show: false,
          left: "52%",
          top: "40%",
          bottom: "10%",
          width: "0%"
        },
        // 右边
        {
          show: false,
          right: "2%",
          top: "40%",
          bottom: "10%",
          containLabel: true,
          width: "37%"
        }
      ],
      xAxis: [
        {
          type: "value",
          inverse: true,
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgba(45, 67, 119, 0.8)"
            }
          },
          axisTick: {
            show: false
          },
          position: "bottom",
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#2D4377",
              type: "dashed"
            }
          }
        },
        {
          gridIndex: 1,
          show: false
        },
        {
          gridIndex: 2,
          axisLine: {
            show: false,
            lineStyle: {
              color: "rgba(45, 67, 119, 0.8)"
            }
          },
          axisTick: {
            show: false
          },
          position: "bottom",
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: "#2D4377",
              type: "dashed"
            }
          }
        }
      ],
      yAxis: [
        {
          type: "category",
          inverse: true,
          position: "right",
          axisLine: {
            show: false
          },

          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          data: labelData
        },
        {
          gridIndex: 1,
          type: "category",
          inverse: true,
          position: "left",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            // padding:[10,0,0,0],
            textStyle: {
              color: "#000",
              fontSize: 0.11 * fontSize
            },
            align: "center"
          },
          data: labelData.map(function(value) {
            return {
              value: value,
              textStyle: {
                align: "center"
              }
            };
          })
        },
        {
          gridIndex: 2,
          type: "category",
          inverse: true,
          position: "left",
          axisLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: false
          },
          data: leftData
        }
      ],
      series: []
    },
    options: []
  };

  option.options.push({
    series: [
      {
        name: "车次",
        type: "bar",
        barWidth: 0.11 * fontSize,
        stack: "1",
        itemStyle: {
          normal: {
            show: true,
            color: new Echarts.graphic.LinearGradient(
              0,
              0,
              1,
              0,
              [
                {
                  offset: 0,
                  color: "#34BA66" // 0% 处的颜色
                },
                {
                  offset: 0.8,
                  color: "#34BA66" // 100% 处的颜色
                },
                {
                  offset: 1,
                  color: "#fff" // 100% 处的颜色
                }
              ],
              false
            ),
            barBorderRadius: 50,
            borderWidth: 0,
            borderColor: "#A7A7A7",
            label: {
              show: true,
              position: "left",
              formatter: function(v) {
                return v.value;
              }
            }
          }
        },
        label: {
          normal: {
            show: false
          }
        },
        data: leftData,
        animationEasing: "elasticOut"
      },
      {
        name: "车辆行驶总里程",
        type: "bar",
        stack: "2",
        barWidth: 0.11 * fontSize,
        xAxisIndex: 2,
        yAxisIndex: 2,
        itemStyle: {
          normal: {
            show: true,
            color: new Echarts.graphic.LinearGradient(
              0,
              0,
              1,
              0,
              [
                {
                  offset: 0,
                  color: "#fff" // 0% 处的颜色
                },
                {
                  offset: 0.2,
                  color: "#FF6349" // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "#FF6349" // 100% 处的颜色
                }
              ],
              false
            ),
            barBorderRadius: 50,
            borderWidth: 0,
            borderColor: "#A7A7A7",
            label: {
              show: true,
              position: "right",
              formatter: function(v) {
                return v.value;
              }
            }
          }
        },
        label: {
          normal: {
            show: false
          }
        },
        data: rightData,
        animationEasing: "elasticOut"
      }
    ]
  });

  myChart.setOption(option);
  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
    myChart.resize();
  });
}

function drawCellTopChart(el, { category = [] }) {
  const myChart = Echarts.init(el);
  let bgData = []; // 最大值用作背景显示的数据
  let maxValue = category[0].value; //最大值
  category.forEach(element => {
    bgData.push({
      name: element.name,
      value: maxValue,
      type: element.type
    });
  });
  let yName = category.map(item => item.name);
  const option = {
    xAxis: {
      splitLine: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        show: false
      },
      axisTick: {
        show: false
      }
    },
    grid: {
      left: 0.4 * fontSize,
      top: 0.4 * fontSize,
      right: 0.9 * fontSize,
      bottom: 0.05 * fontSize
    },
    yAxis: [
      {
        inverse: true,
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          show: true,
          padding: [0, 0, 0.35 * fontSize, 0],
          inside: true,
          textStyle: {
            fontSize: 0.14 * fontSize,
            color: "#333",
            align: "left"
          },
          formatter: "{value}",
          rich: {
            a: {
              color: "transparent",
              fontSize: 0.14 * fontSize,
              shadowColor: "rgba(0, 0, 0, 1)"
            }
          }
        },
        data: yName
      },
      {
        // y轴最左侧的文字
        axisTick: "none",
        axisLine: "none",
        position: "left",
        axisLabel: {
          padding: [
            0.08 * fontSize,
            0.05 * fontSize,
            0.06 * fontSize,
            0.1 * fontSize
          ], // 调整文字位置
          textStyle: {
            color: "#000",
            fontSize: 0.12 * fontSize,
            fontWeight: "400"
          },
          formatter: "{value}"
        },
        data: [5, 4, 3, 2, 1]
      },
      {
        // y轴最右侧的文字
        inverse: true,
        axisTick: "none",
        axisLine: "none",
        type: "category",
        axisLabel: {
          margin: 0.1 * fontSize,
          textStyle: {
            color: "#000",
            fontSize: 0.16 * fontSize
          }
        },
        data: category
      }
    ],
    series: [
      {
        // 背景样式
        name: "背景",
        type: "bar",
        barWidth: 0.15 * fontSize,
        stack: "总量",
        barGap: "-100%",
        symbol: "fixed",
        symbolRepeat: "repeat",
        legendHoverLink: false,
        itemStyle: {
          normal: {
            color: "rgba(153, 153, 153, 0)"
          }
        },
        data: bgData,
        animation: false, //关闭动画
        z: 0
      },
      {
        name: "info",
        // 内（显示的内容）
        type: "bar",
        barGap: "-100%",
        barWidth: 0.15 * fontSize,
        legendHoverLink: false,
        silent: true,
        itemStyle: {
          normal: {
            color: function() {
              const color = {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#1FFD95" // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#EFF639" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#FF432B" // 100% 处的颜色
                  }
                ]
              };
              return color;
            }
          }
        },
        data: category,
        z: 1,
        animationEasing: "elasticOut"
      },
      {
        // 分隔
        type: "pictorialBar",
        itemStyle: {
          normal: {
            color: "rgba(255,255,255,1)"
          }
        },
        symbolRepeat: "fixed",
        symbolMargin: 2,
        symbol: "rect",
        symbolClip: true,
        symbolSize: [0.02 * fontSize, 0.15 * fontSize],
        symbolPosition: "start",
        symbolOffset: [0, 0],
        symbolBoundingData: maxValue,
        data: bgData,
        animation: false, //关闭动画
        z: 2
      }
    ]
  };

  myChart.setOption(option);
  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
    myChart.resize();
  });
}

function drawFlowMapChart(el, chinaDatas = []) {
  const myChart = Echarts.init(el);
  // 注册地图
  Echarts.registerMap("china", china);
  let chinaGeoCoordMap = {
    黑龙江: [127.9688, 45.368],
    内蒙古: [110.3467, 41.4899],
    吉林: [125.8154, 44.2584],
    北京: [116.4551, 40.2539],
    辽宁: [123.1238, 42.1216],
    河北: [114.4995, 38.1006],
    天津: [117.4219, 39.4189],
    山西: [112.3352, 37.9413],
    陕西: [109.1162, 34.2004],
    甘肃: [103.5901, 36.3043],
    宁夏: [106.3586, 38.1775],
    青海: [101.4038, 36.8207],
    新疆: [87.9236, 43.5883],
    西藏: [91.11, 29.97],
    四川: [103.9526, 30.7617],
    重庆: [108.384366, 30.439702],
    山东: [117.1582, 36.8701],
    河南: [113.4668, 34.6234],
    江苏: [118.8062, 31.9208],
    安徽: [117.29, 32.0581],
    湖北: [114.3896, 30.6628],
    浙江: [119.5313, 29.8773],
    福建: [119.4543, 25.9222],
    江西: [116.0046, 28.6633],
    湖南: [113.0823, 28.2568],
    贵州: [106.6992, 26.7682],
    云南: [102.9199, 25.4663],
    广东: [113.12244, 23.009505],
    广西: [108.479, 23.1152],
    海南: [110.3893, 19.8516],
    上海: [121.4648, 31.2891],
    台湾: [121.509062, 25.044332],
    香港: [114.05279, 22.31585],
    澳门: [113.588, 22.16052]
  };
  const regions = [];
  for (let key in chinaGeoCoordMap) {
    if (
      key === "新疆" ||
      key === "海南" ||
      key === "四川" ||
      key === "湖南" ||
      key === "福建" ||
      key === "辽宁" ||
      key === "河南" ||
      key === "宁夏" ||
      key === "北京"
    ) {
      regions.push({
        name: key, //区块名称
        itemStyle: {
          normal: {
            areaColor: "#F8E3EE"
          }
        }
      });
    } else if (
      key === "内蒙古" ||
      key === "浙江" ||
      key === "湖北" ||
      key === "云南" ||
      key === "广东" ||
      key === "山东"
    ) {
      regions.push({
        name: key, //区块名称
        itemStyle: {
          normal: {
            areaColor: "#D8DCE8"
          }
        }
      });
    } else if (
      key === "黑龙江" ||
      key === "甘肃" ||
      key === "山西" ||
      key === "安徽" ||
      key === "贵州" ||
      key === "天津"
    ) {
      regions.push({
        name: key, //区块名称
        itemStyle: {
          normal: {
            areaColor: "#DAEABE"
          }
        }
      });
    } else {
      regions.push({
        name: key, //区块名称
        itemStyle: {
          normal: {
            areaColor: "#F9F5D0"
          }
        }
      });
    }
  }

  let convertData = function(data) {
    let res = [];
    for (let i = 0; i < data.length; i++) {
      let dataItem = data[i];
      let fromCoord = [113.12244, 23.009505];
      let toCoord = chinaGeoCoordMap[dataItem[0].name];
      if (fromCoord && toCoord) {
        res.push([
          {
            coord: fromCoord,
            value: dataItem[0].value
          },
          {
            coord: toCoord
          }
        ]);
      }
    }
    return res;
  };
  let series = [];
  [["广东", chinaDatas]].forEach(function(item) {
    series.push(
      {
        type: "lines",
        zlevel: 1,
        effect: {
          show: true,
          period: 4, //箭头指向速度，值越小速度越快
          trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
          symbol: "arrow", //箭头图标
          symbolSize: 5, //图标大小
          color: "#33cc33"
        },
        lineStyle: {
          normal: {
            width: 1, //尾迹线条宽度
            opacity: 1, //尾迹线条透明度
            curveness: -0.5, //尾迹线条曲直度
            color: "#33cc33"
          }
        },
        label: {
          show: false, // 显示省份名称
          color: "#04CFF5",
          align: "center"
        },
        data: convertData(item[1])
      },
      {
        type: "effectScatter",
        coordinateSystem: "geo",
        showEffectOn: "render",
        // zlevel: 2, // zlevel用于 Canvas 分层 相同的绘制在同一个canvas上
        rippleEffect: {
          number: 5, // 波纹数量
          period: 4, // 动画周期 数值越大，波动越慢
          scale: 3.5, // 动画中波纹的最大缩放比例
          brushType: "stroke" // 波纹的绘制方式 stroke fill
        },
        symbol: "circle",
        symbolSize: 10,
        itemStyle: {
          normal: {
            color: "#6666FF",
            shadowBlur: 10,
            shadowColor: "#6666FF"
          }
        },
        formatter: function(params) {
          //根据业务自己拓展要显示的内容
          let res = "";
          let name = params.name;
          let value = params.value[params.seriesIndex + 1];
          res =
            "<span style='color:#fff;'>" + name + "</span><br/>数据：" + value;
          return res;
        },
        data: item[1].map(function(dataItem) {
          return {
            name: dataItem[0].name, // json数据里的名称可能和地图数据名称对不上，记得修改省份名称
            value: chinaGeoCoordMap[dataItem[0].name].concat([
              dataItem[0].value
            ])
          };
        }),
        z: 4
      }
    );
  });

  const option = {
    tooltip: {
      trigger: "item",
      showDelay: 0,
      hideDelay: 0,
      enterable: true,
      transitionDuration: 0,
      extraCssText: "z-index:100",
      formatter: ""
    },
    geo: {
      map: "china",
      zoom: 1.2,
      label: {
        emphasis: {
          show: false
        }
      },
      roam: true, //是否允许缩放
      itemStyle: {
        normal: {
          color: "#fff", //地图背景色
          borderColor: "#999", //省市边界线00fcff 516a89
          borderWidth: 1
        },
        emphasis: {
          show: false
        }
      },
      regions: regions
    },
    series: series
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
    myChart.resize();
  });
}

// 省内迁移图
function drawProvincesFlowMapChart(el, { point_circle = [], point_line = [] }) {
  const myChart = Echarts.init(el);
  // 城市标记数据
  // const point_circle = [
  //   {
  //     value: [113.12244, 23.009505],
  //     label: {
  //       name: "广州市"
  //     }
  //   },
  //   {
  //     value: [113.271431, 23.135336],
  //     label: {
  //       name: "惠州市"
  //     }
  //   },
  //   {
  //     value: [110.93154, 21.66906],
  //     label: {
  //       name: "茂名市"
  //     }
  //   },
  //   {
  //     value: [116.37852, 23.55574],
  //     label: {
  //       name: "揭阳市"
  //     }
  //   }
  // ];
  // 流向线条的经纬度，可自定义样式
  // const point_line = [
  //   {
  //     coords: [
  //       [113.12244, 23.009505], // 初始点经纬度
  //       [113.271431, 23.135336] //目标点经纬度
  //     ],
  //     label: {
  //       start: "广州市",
  //       end: "惠州市"
  //     }
  //   },
  //   {
  //     coords: [
  //       [110.93154, 21.66906],
  //       [116.37852, 23.55574]
  //     ],
  //     label: {
  //       start: "茂名市",
  //       end: "揭阳市"
  //     }
  //   }
  // ];
  Echarts.registerMap("广东", guangdong);
  const option = {
    tooltip: {
      formatter: () => "",
      textStyle: {
        color: "#fff"
      }
    },
    backgroundColor: "#fff",
    geo: {
      map: "广东",
      center: [113.23, 23.16],
      zoom: 1,
      roam: true,
      itemStyle: {
        borderWidth: 1,
        areaColor: {
          type: "radial",
          x: 0.5,
          y: 0.5,
          r: 0.8,
          colorStops: [
            {
              offset: 0,
              color: "#F9E3EF" // 0% 处的颜色
            },
            {
              offset: 1,
              color: "#F9E3EF" // 100% 处的颜色
            }
          ]
        },
        borderColor: "#999"
      },
      tooltip: {
        formatter: () => ""
      },
      emphasis: {
        //地图高亮
        itemStyle: {
          color: "#93EBF8"
        }
      }
    },
    series: [
      {
        type: "lines",
        zlevel: 2,
        effect: {
          show: true,
          symbolSize: 5,
          color: "#E4AA0C",
          symbol: "arrow"
        },
        lineStyle: {
          color: "#33cc33",
          width: 1, //线条宽度
          curveness: 0.3
        },
        tooltip: {
          formatter({ data }) {
            return `流向走向如下：<br />
              起点：${data.label.start}<br />
              终点：${data.label.end}
              `;
          },
          backgroundColor: "rgba(245,108,45,0.5)"
        },
        data: point_line
      },
      {
        type: "effectScatter",
        coordinateSystem: "geo",
        rippleEffect: {
          number: 2,
          scale: 3,
          brushType: "stroke"
        },
        itemStyle: {
          color: "#F56828"
        },
        tooltip: {
          formatter({ data }) {
            return `地点位于：${data.label}`;
          },
          backgroundColor: "rgba(232,85,160,0.5)"
        },
        label: {
          show: true,
          offset: [40, 0],
          color: "#F56828",
          formatter({ data }) {
            return `${data.label}`;
          }
        },
        data: point_circle
      } //地图线的动画效果,
    ]
  };
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
    myChart.resize();
  });
}

function drawBevellChart(el, { dataX = [], dataValue = [] }) {
  const myChart = Echarts.init(el);
  const myShape = {
    x: 0,
    y: 0,
    width: 13 //间距
  };
  // 绘制左侧面
  const InclinedRoofBar = Echarts.graphic.extendShape({
    shape: myShape,
    buildPath: function(ctx, shape) {
      // canvas，shape是从custom传入的
      const xAxisPoint = shape.xAxisPoint;
      const c0 = [shape.x, shape.y];
      const c1 = [shape.x - 17, shape.y - 10];
      const c2 = [xAxisPoint[0] - 17, xAxisPoint[1]];
      const c3 = [xAxisPoint[0], xAxisPoint[1]];
      ctx
        .moveTo(c0[0], c0[1])
        .lineTo(c1[0], c1[1])
        .lineTo(c2[0], c2[1])
        .lineTo(c3[0], c3[1])
        .closePath();
    }
  });
  const colorList = ["#F9D3AB", "#8493F8", "#79E57C", "#F3ADAD", "#6CE2BF"];

  Echarts.graphic.registerShape("InclinedRoofBar", InclinedRoofBar);
  const option = {
    color: ["#b27e44"],
    tooltip: {
      show: true,
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      },
      confine: true,
      textStyle: {
        fontSize: 0.14 * fontSize
      },
      formatter: params => {
        var tar = params[0];
        this.workType = tar.name;
        return tar.name + " : " + tar.value;
      }
    },
    legend: {
      top: 5,
      itemWidth: 16,
      itemHeight: 8,
      left: "center",
      padding: 0,
      textStyle: {
        color: "#fff",
        fontSize: 0.14 * fontSize,
        padding: [2, 0, 0, 0]
      },
      data: ["demo"]
    },
    grid: {
      containLabel: true,
      left: 0,
      right: 0,
      bottom: 0,
      top: 40,
      width: "95%",
      height: "85%"
    },
    xAxis: {
      type: "category",
      axisLine: {
        show: true,
        lineStyle: {
          width: 1,
          color: "rgb(0, 255, 255, 0.5)"
        }
      },
      axisLabel: {
        show: true,
        textStyle: {
          color: "#000",
          fontSize: 0.12 * fontSize
        },
        formatter: function(text) {
          const textLength = text.length;
          const textList = [];
          for (let i = 0; i < textLength / 5; i++) {
            let strList = text.substr(i, (i + 1) * 5);
            textList.push(strList);
          }
          let textStr = "";
          textList.forEach(i => {
            textStr += i + "\n";
          });
          return textStr;
        }
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: "rgb(255, 255, 255, 0.3)",
          type: "dashed",
          width: 1
        }
      },
      axisTick: {
        show: false
      },
      data: [],
      zlevel: 10
    },
    yAxis: {
      type: "value",
      name: "",
      min: 0,
      axisTick: {
        show: false
      },
      axisLabel: {
        textStyle: {
          color: "#fff",
          fontSize: 0.12 * fontSize
        }
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "rgb(255, 255, 255, 0.3)",
          type: "dashed",
          width: 0.7
        }
      },
      axisLine: {
        show: false,
        lineStyle: {
          color: "rgb(52, 113, 250)"
        }
      },
      nameTextStyle: {
        color: "#fff",
        fontSize: 0.16 * fontSize
      }
    },
    series: [
      {
        type: "custom",
        name: "",
        renderItem: (params, api) => {
          const location = api.coord([api.value(0), api.value(1)]);
          const xlocation = api.coord([api.value(0), 0]);
          return {
            type: "InclinedRoofBar",
            shape: {
              api,
              xValue: api.value(0),
              yValue: api.value(1),
              x: location[0] + 10,
              y: location[1],
              xAxisPoint: [xlocation[0] + 10, xlocation[1]]
            },
            style: {
              fill: new Echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: colorList[params.dataIndex]
                },
                {
                  offset: 1,
                  color: "#fff"
                }
              ])
            }
          };
        },
        data: []
      },
      {
        type: "bar",
        label: {
          normal: {
            show: true,
            position: "right",
            fontSize: 0.14 * fontSize,
            offset: [15, 0]
          }
        },
        showBackground: false,
        barWidth: 14,
        itemStyle: {
          color: "transparent"
        },
        tooltip: {
          show: false
        },
        data: []
      }
      // {
      //   type: "pictorialBar",
      //   data: [90, 90, 90, 90, 90],
      //   xAxisIndex: 0,
      //   yAxisIndex: 0,
      //   zlevel: 99,
      //   symbol:
      //     "image://data:image/png;base64,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",
      //   symbolRotate: 77,
      //   symbolSize: [15, 20],
      //   symbolPosition: "end",
      //   symbolOffset: [3, -20],
      //   itemStyle: {
      //     color: "#000",
      //     shadowColor: "rgba(29,255,252, 0.8)",
      //     shadowBlur: 10
      //   },
      //   tooltip: {
      //     show: false
      //   }
      // }
    ]
  };
  const { xAxis, series } = option;

  xAxis.data = dataX.map(name => name);
  series[0].data = dataValue.map(value => value);
  // series[2].data = dataValue.map(value => value);
  myChart.setOption(option);
  window.addEventListener("resize", () => {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
    myChart.resize();
  });
}

function resizeEcharts() {
  window.addEventListener("resize", function() {
    const windowWidth = window.innerWidth;
    fontSize = windowWidth / 20; // 根据需要调整比例
  });
}

export default {
  drawTopChart,
  drawPillarLineChart,
  drawPillarChart,
  drawDashBoardChart,
  drawRakingChart,
  drawContrastChart,
  drawCellTopChart,
  drawFlowMapChart,
  drawProvincesFlowMapChart,
  drawBevellChart,
  resizeEcharts
};
